import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './LibraryUploadFile.css';

const LIBRARY_ROOT = process.env.REACT_APP_START_PATH || '/library';

function LibraryUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={LIBRARY_ROOT}
      sessionPrefix="library_file"
    />
  );
}

LibraryUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default LibraryUploadFile;
